<template>
  <div class="news">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link" style="color: #3498db;">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 主要内容 -->
    <main class="news-main">
      <div class="container">
        <!-- 页面标题 -->
        <section class="page-header">
          <h1>行业资讯</h1>
          <p>了解最新的健康科技行业动态和资讯</p>
        </section>

        <!-- 新闻分类 -->
        <section class="news-categories">
          <div class="category-tabs">
            <button 
              v-for="category in categories" 
              :key="category.id"
              :class="['category-tab', { active: currentCategory === category.id }]"
              @click="selectCategory(category.id)"
            >
              {{ category.name }}
            </button>
          </div>
        </section>

        <!-- 新闻列表 -->
        <section class="news-list">
          <div class="news-grid">
            <article 
              v-for="article in filteredNews" 
              :key="article.id"
              class="news-card"
              @click="viewArticle(article)"
            >
              <div class="news-image">
                <div class="image-placeholder">{{ article.image }}</div>
                <div class="news-category">{{ article.category }}</div>
              </div>
              <div class="news-content">
                <h3 class="news-title">{{ article.title }}</h3>
                <p class="news-summary">{{ article.summary }}</p>
                <div class="news-meta">
                  <span class="date">{{ article.date }}</span>
                  <span class="views">{{ article.views }} 阅读</span>
                </div>
              </div>
            </article>
          </div>

          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="totalArticles"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </section>
      </div>
    </main>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关于我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;">© 2026 北京和合网链科技发展有限公司 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      phone: '',
      login: false,
      currentCategory: 'all',
      currentPage: 1,
      pageSize: 9,
      categories: [
        { id: 'all', name: '全部' },
        { id: 'industry', name: '行业动态' },
        { id: 'technology', name: '科技前沿' },
        { id: 'health', name: '健康资讯' },
        { id: 'policy', name: '政策法规' }
      ],
      articles: [
        {
          id: 1,
          title: '量子健康检测技术获得重大突破',
          summary: '最新研究显示，量子健康检测技术在早期疾病筛查方面取得重大进展，准确率提升至95%以上。',
          image: '🔬',
          category: '科技前沿',
          categoryId: 'technology',
          date: '2025-01-15',
          views: 1523
        },
        {
          id: 2,
          title: '国家卫健委发布健康管理新指南',
          summary: '国家卫生健康委员会发布最新健康管理指南，强调预防为主、早期干预的重要性。',
          image: '📋',
          category: '政策法规',
          categoryId: 'policy',
          date: '2026-01-12',
          views: 892
        },
        {
          id: 3,
          title: '慢性病管理市场规模持续增长',
          summary: '据最新市场研究报告显示，中国慢性病管理市场规模预计在2025年将达到5000亿元。',
          image: '📊',
          category: '行业动态',
          categoryId: 'industry',
          date: '2025-01-10',
          views: 756
        },
        {
          id: 4,
          title: 'AI辅助诊断在健康检测中的应用',
          summary: '人工智能技术在健康检测领域的应用日益广泛，大幅提升了检测效率和准确性。',
          image: '🤖',
          category: '科技前沿',
          categoryId: 'technology',
          date: '2025-01-08',
          views: 1245
        },
        {
          id: 5,
          title: '冬季健康管理注意事项',
          summary: '专家提醒，冬季是慢性病高发季节，需要特别注意健康管理，合理饮食和适度运动。',
          image: '❄️',
          category: '健康资讯',
          categoryId: 'health',
          date: '2025-01-05',
          views: 634
        },
        {
          id: 6,
          title: '健康产业发展前景分析',
          summary: '随着人口老龄化加剧和健康意识提升，健康产业迎来前所未有的发展机遇。',
          image: '🏥',
          category: '行业动态',
          categoryId: 'industry',
          date: '2026-01-03',
          views: 987
        }
      ]
    }
  },
  computed: {
    filteredNews() {
      if (this.currentCategory === 'all') {
        return this.articles
      }
      return this.articles.filter(article => article.categoryId === this.currentCategory)
    },
    totalArticles() {
      return this.filteredNews.length
    }
  },
  methods: {
    selectCategory(categoryId) {
      this.currentCategory = categoryId
      this.currentPage = 1
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    viewArticle(article) {
      this.$router.push({
        path: '/news-detail',
        query: { id: article.id }
      })
    },
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}
.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-active {
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

.news {
  padding-top: 80px;
}

.breadcrumb {
  padding: 20px 0;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.breadcrumb .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb a {
  color: #3498db;
  text-decoration: none;
}

.breadcrumb .separator {
  margin: 0 10px;
  color: #6c757d;
}

.breadcrumb .current {
  color: #2c3e50;
  font-weight: 500;
}

.news-main {
  padding: 60px 0;
}

.page-header {
  text-align: center;
  margin-bottom: 50px;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.1rem;
  color: #6c757d;
}

.news-categories {
  margin-bottom: 40px;
}

.category-tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.category-tab {
  padding: 10px 25px;
  border: 2px solid #e9ecef;
  background: white;
  color: #6c757d;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.category-tab:hover {
  border-color: #3498db;
  color: #3498db;
}

.category-tab.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

.news-list {
  margin-top: 40px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
}

.news-card {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.news-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

.news-image {
  position: relative;
  height: 200px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.image-placeholder {
  font-size: 3rem;
  opacity: 0.8;
}

.news-category {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255,255,255,0.9);
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #3498db;
}

.news-content {
  padding: 25px;
}

.news-title {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.4;
  font-weight: 600;
}

.news-summary {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #adb5bd;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    display: none;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .overview-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .expert-card {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .booking-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .process-flow {
    flex-direction: column;
  }

  .process-arrow {
    transform: rotate(90deg);
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .category-tabs {
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 10px;
  }
}
</style>